import React from 'react';
import styled from 'styled-components';

const A5Style = styled.svg``;

export const A5 = ({ color }) => {
	return (
		<A5Style
			xmlns='http://www.w3.org/2000/svg'
			width='22.271'
			height='22.266'
			viewBox='0 0 22.271 22.266'
		>
			<path
				id='Guitar'
				d='M876.937,535.99a.512.512,0,1,1,.729-.72l1.938,1.938a.512.512,0,1,1-.729.72l-1.938-1.938Zm-1.865-4.445a5.637,5.637,0,0,1,1.743-.51,1.2,1.2,0,0,0,.535-.207,1.06,1.06,0,0,0,.341-.438,4.108,4.108,0,0,1,3.542-2.521,5.02,5.02,0,0,1,2.363.531l4.721-4.721v-.213a.855.855,0,0,1,.3-.647l2.231-2.233a.875.875,0,0,1,.608-.249h.79a.852.852,0,0,1,.644.294l1.39,1.388a.844.844,0,0,1,.249.609h.007v.79a.849.849,0,0,1-.3.647l-2.231,2.233a.852.852,0,0,1-.645.249h-.17l-4.721,4.725a5.119,5.119,0,0,1,.529,2.363,4.112,4.112,0,0,1-2.521,3.542,1.076,1.076,0,0,0-.438.341,1.1,1.1,0,0,0-.207.535,5.447,5.447,0,0,1-.51,1.741,4.673,4.673,0,0,1-5.02,2.736,8.342,8.342,0,0,1-5.967-5.967,4.677,4.677,0,0,1,2.735-5.019Zm.741,1.54a2.981,2.981,0,0,0-1.793,3.177,6.689,6.689,0,0,0,4.588,4.586,2.973,2.973,0,0,0,3.172-1.8,3.841,3.841,0,0,0,.365-1.21,2.693,2.693,0,0,1,1.641-2.224,2.425,2.425,0,0,0,1.507-2.05,3.687,3.687,0,0,0-.577-1.957.855.855,0,0,1,.1-1.1l5.414-5.418h0a.889.889,0,0,1,.608-.249h.207l1.773-1.774v-.087l-.923-.93h-.085l-1.774,1.771v.216a.844.844,0,0,1-.255.6l-5.42,5.42v0a.848.848,0,0,1-1.039.127,3.736,3.736,0,0,0-2.012-.61,2.444,2.444,0,0,0-2.053,1.516,2.721,2.721,0,0,1-2.225,1.635,4.058,4.058,0,0,0-1.214.361Zm6.063-1.984a1.887,1.887,0,1,1-1.883,1.887,1.891,1.891,0,0,1,1.883-1.887Zm-.85,1.887a.856.856,0,1,0,.85-.857.855.855,0,0,0-.85.857Z'
				transform='translate(-872.264 -520.338)'
				fill={color}
			/>
		</A5Style>
	);
};
